export default __webpack_public_path__ + "static/media/orders-page-background.d6af441d.jpg";